<!-- 知识模块的移动复制 -->
<template>
  <div class="moveconent">
    <el-dialog v-dialogDrag :title="copyMoveTitle" width="30%" :before-close="handleClose" :visible.sync="openModify"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <span>当前选择为:{{ folderName }}</span>
      <el-tree
        ref="tree"
        :load="loadNode"
        :props="defaultProps"
        lazy
        accordion
        highlight-current
        node-key="folderId"
        :default-expanded-keys="unfoldIdArr"
        :render-content="renderContent"
        @node-click="clickNodeTree">
      </el-tree>
      <template #footer>
        <span class="dialog-footer">
          <el-button size="small" @click="handleClose">取 消</el-button>
          <el-button type="primary" size="small" @click="trueMoveOrCopy">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { treeNodeIcon } from "@/CommonDP/utils/docPublic";
import docService from "@/CommonDP/service/doc-service";
import secondaryMenuService from "@/CommonDP/service/secondaryMenu-service";
import { mapState } from "vuex";
export default {
  name: "MoveAndCopy",
  props: {
    type: { default: 0, type: Number } //   2 个人文档 3企业文档 4部门文档
  },
  data() {
    return {
      openModify: true,
      defaultProps: { children: "children", label: "folderName" },
      unfoldIdArr: [],
      argument: {
        folderId: "0",
        isRead: 1,
        priviAll: "1",
        enterpriseId: "",
        versionId: "",
        isPersonal: 1,
        noRightClickMenu: true,
        type: ""
      },
      folderName: "",
      folderTempId: ""
    };
  },
  computed: {
    ...mapState({
      selectArr: (state) => state.XtDesign.selectArr,
      copyMoveTitle: (state) => state.perFile.copyMoveTitle,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    }),
    prjId() {
      if (this.type === 2) return "MyDoc";
      else if (this.type === 3) return "EnterpriseDoc";
      else if (this.type === 4) return "EnterpriseDeptDoc";
      else return "";
    }
  },
  watch: {},
  mounted() {
    this.argument.enterpriseId = this.enterpriseId;
  },
  methods: {
    trueMoveOrCopy() {
      if (this.folderTempId === this.userInfo.userId) {
        this.$message.warning("不能" + this.copyMoveTitle + "当前目录下");
      } else {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: true,
          message: "操作中..."
        });
        const idTemp = [];
        for (let i = 0; i < this.selectArr.length; i++) {
          idTemp.push(this.selectArr[i].folderId);
        }
        const param = {
          ids: idTemp,
          prjId: this.prjId,
          enterpriseId: this.enterpriseId,
          parentId: this.folderTempId
        };
        const chooseList = [];
        this.selectArr.forEach((item) => {
          chooseList.push(item.folderId);
        });

        if (this.copyMoveTitle == "移动到") {
          if (chooseList.includes(this.folderTempId)) {
            this.$message.warning("不能移动到当前目录下");
            this.$store.dispatch("perFileUpdateMessageObj", {
              isShow: false,
              message: ""
            });
          } else {
            docService.moveFile(param).then((res) => {
              if (res.result === "0") {
                this.$message.success("移动成功");
                this.$emit("pf3");
                this.$store.dispatch("perFileMoveAndCopy", false);
                this.$store.dispatch("perFileUpdateNodeList");
                this.$store.dispatch("perFileUpdateMessageObj", {
                  isShow: false,
                  message: ""
                });
              }
            });
          }
        } else {
          if (chooseList.includes(this.folderTempId)) {
            this.$message.warning("不能复制到当前目录下");
            this.$store.dispatch("perFileUpdateMessageObj", {
              isShow: false,
              message: ""
            });
          } else {
            docService.copyFile(param).then((res) => {
              if (res.result === "0") {
                this.$message({
                  duration: 1000,
                  message: "复制成功",
                  type: "success",
                  showClose: true
                });
                this.$emit("pf3");
                this.$store.dispatch("perFileMoveAndCopy", false);
                this.$store.dispatch("perFileUpdateNodeList");
                this.$store.dispatch("perFileUpdateMessageObj", {
                  isShow: false,
                  message: ""
                });
              }
            });
          }
        }
      }
    },
    handleClose() {
      this.$store.dispatch("perFileMoveAndCopy", false);
    },
    async loadNode(node, resolve) {
      if (node.level === 0) {
        try {
          if (this.type === 2) {
            const result = await docService.querypersonalTree(this.argument);
            if (result.result === "0") {
              if (result.data[0]) {
                this.folderName = result.data[0].folderName;
                this.folderTempId = result.data[0].folderId;

                this.unfoldIdArr.push(result.data[0].folderId);
              } else result.data = [];
              result.data.splice(1, 3);
              resolve(result.data);
            }
          } else if (this.type === 3) {
            this.folderName = '企业文档';
            this.folderTempId = '0';
            this.unfoldIdArr.push('0');
            resolve([{
              folderName: this.folderName,
              folderId: '0'
            }]);
          } else if (this.type === 4) {
            const result = await secondaryMenuService.queryEnterpriseDept(this.argument);
            const obj = result.data.filter(({ folderId }) => folderId === this.$route.name)[0];
            this.folderName = obj.folderName;
            this.folderTempId = obj.folderId;
            this.unfoldIdArr.push(obj.folderId);
            resolve([obj]);
          }
        } catch (e) {
          console.log(e);
        }
      } else {
        this.getChildren(node, resolve);
      }
    },
    async getChildren(node, resolve) {
      const { data } = node;
      const { folderId } = data;
      this.folderName = data.folderName;
      this.folderTempId = data.folderId;
      this.$nextTick(() => {
        if (this.$refs.tree) this.$refs.tree.setCurrentKey(folderId);
      });
      const requestType = this.requestType(data, node);
      try {
        const result = await requestType;
        const newData = this._isFolder(result.data);
        if (resolve) {
          resolve(newData);
        } else {
          node.childNodes = [];
          node.doCreateChildren(newData);
        }
      } catch (e) {
        this.$message.warning(e.message || "请求处理失败");
      }
    },
    async requestType(data, node) {
      let Request;
      const enterpriseId = this.enterpriseId;
      if (data.folderId === "recycle") {
        Request = docService.querypersonalRecycle(enterpriseId);
      } else {
        if (node.level === 0) {
          this.argument.folderId = "0";
        } else {
          if (this.type === 2) {
            this.argument.folderId = data.folderId;
            Request = docService.querypersonalTree(this.argument);
          } else if (this.type === 3) {
            this.argument = {
              ...this.argument,
              folderId: data.folderId
            };
            Request = docService.queryenterpriseTree(this.argument);
          } else if (this.type === 4) {
            this.argument.folderId = data.folderId;
            Request = secondaryMenuService.queryEnterpriseDept(this.argument);
          }
        }
      }
      return Request;
    },

    _isFolder(data) {
      return data.filter((item) => item.isFolder === 1);
    },
    async clickNodeTree(data) {
      this.folderName = data.folderName;
      this.folderTempId = data.folderId;
    },

    renderContent(h, { node }) {
      return h(
        "div",
        {
          style: "display:flex;align-items:center;width:100%;overflow: hidden;padding-right:25px"
        },
        [
          h("img", {
            attrs: {
              src: treeNodeIcon(node.data)
            },
            style: "margin-right:6px"
          }),
          h("div", {
            domProps: {
              innerText: node.label
            },
            attrs: {
              class: "ellipsis",
              title: node.label
            }
          })
        ]
      );
    }
  }
};
</script>

<style scoped lang="scss"></style>
